import days from '../components/home/days'
import gallery from '../components/home/gallery'
import who from '../components/home/who'

const home = {
  init() {
    if (!$q('.page-template-home').first) return

    who.init()
    days.init()
  },
  load() {
    gallery.init()
  }
}
export default home
